import { openTalkativeUI } from "./helpers/get-talkative-elements.js";
import { useTranslation } from "react-i18next";
import { Anchor, Body1, Flex, IconSupportAgent } from "@myphx-engineering/phx-design-system";
import { jsx, jsxs } from "react/jsx-runtime";

//#region src/TalkativeWidget.tsx
const TalkativeWidget = ({ onClick = openTalkativeUI }) => {
	const { t } = useTranslation("tlk");
	return /* @__PURE__ */ jsxs(Flex, {
		align: "center",
		gap: "xxxs",
		children: [
			/* @__PURE__ */ jsx(IconSupportAgent, { color: "secondary" }),
			/* @__PURE__ */ jsx(Body1, { children: t("talkativeWidget.needHelp") }),
			/* @__PURE__ */ jsx(Anchor, {
				onClick,
				children: t("talkativeWidget.contactUs")
			})
		]
	});
};

//#endregion
export { TalkativeWidget };